import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-temp-cold')
export class ObiTempCold extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M15 11H9V13H15V11Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40973 21.5903 4.71569 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V16.8C22 17.9201 22 18.4802 21.782 18.908C21.5903 19.2843 21.2843 19.5903 20.908 19.782C20.4802 20 19.9201 20 18.8 20H5.2C4.0799 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V7.2ZM5.2 6H18.8C19.3931 6 19.7176 6.00156 19.9507 6.02061L19.9771 6.0229L19.9794 6.04927C19.9984 6.28244 20 6.60695 20 7.2V16.8C20 17.3931 19.9984 17.7176 19.9794 17.9507L19.9771 17.9771L19.9507 17.9794C19.7176 17.9984 19.3931 18 18.8 18H5.2C4.60695 18 4.28244 17.9984 4.04927 17.9794L4.0229 17.9771L4.02061 17.9507C4.00156 17.7176 4 17.3931 4 16.8V7.2C4 6.60695 4.00156 6.28244 4.02061 6.04927L4.0229 6.0229L4.04927 6.02061C4.28244 6.00156 4.60695 6 5.2 6Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 11H9V13H15V11Z" style="fill: var(--element-active-color)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40973 21.5903 4.71569 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V16.8C22 17.9201 22 18.4802 21.782 18.908C21.5903 19.2843 21.2843 19.5903 20.908 19.782C20.4802 20 19.9201 20 18.8 20H5.2C4.0799 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V7.2ZM5.2 6H18.8C19.3931 6 19.7176 6.00156 19.9507 6.02061L19.9771 6.0229L19.9794 6.04927C19.9984 6.28244 20 6.60695 20 7.2V16.8C20 17.3931 19.9984 17.7176 19.9794 17.9507L19.9771 17.9771L19.9507 17.9794C19.7176 17.9984 19.3931 18 18.8 18H5.2C4.60695 18 4.28244 17.9984 4.04927 17.9794L4.0229 17.9771L4.02061 17.9507C4.00156 17.7176 4 17.3931 4 16.8V7.2C4 6.60695 4.00156 6.28244 4.02061 6.04927L4.0229 6.0229L4.04927 6.02061C4.28244 6.00156 4.60695 6 5.2 6Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-temp-cold': ObiTempCold;
  }
}
